import React, { useContext, useEffect, useMemo, useState } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import Link from '../Nav/Link'
import EnterpriseSetupMeeting from './EnterpriseSetupMeeting'
import Wait from '@react/react-spectrum/Wait'
import {Form} from '@react/react-spectrum/Form'
import Textfield from '@react/react-spectrum/Textfield'
import Textarea from '@react/react-spectrum/Textarea'
import Checkbox from '@react/react-spectrum/Checkbox'
import Button from '@react/react-spectrum/Button'
import FieldLabel from '@react/react-spectrum/FieldLabel/js/FieldLabel'
import { setBodyHeight, logAlert, pUserInfo } from '../../lib/easybake'
import { MAX_STRING_LENGTH, MAX_STRING_LENGTH_LONG } from '../../lib/constants'

export default function EnterpriseForm () {
    /*
    Name *
    Business Name *
    Email address *
    Phone number (optional)
    Use case (optional)
    Estimated volume per year (optional)
    */
    const {
        dispatch,
        formEnterpriseFullName,
        formEnterpriseEmail,
        formEnterpriseCompany,
        formEnterprisePhone,
        formEnterpriseUseCase,
        formEnterpriseEstimatedVolume,
        formEnterpriseAgreement,
        dMode,
        wait,
        page
    } = useContext(EasybakeContext)

    const uInfo = [
        { name: __('enterprise_form_name'), value: formEnterpriseFullName },
        { name: __('enterprise_form_email'), value: formEnterpriseEmail },
        { name: __('enterprise_form_company'), value: formEnterpriseCompany },
        { name: __('enterprise_form_phone'), value: formEnterprisePhone || '' },
        { name: __('enterprise_form_estimated-volume'), value: formEnterpriseEstimatedVolume || '' },
        { name: __('enterprise_form_agreement'), value: formEnterpriseAgreement || '' },
        { name: __('enterprise_form_usecase'), value: formEnterpriseUseCase || '' }
    ]

    useEffect(() => {
            if (window.easybake) {
                window.easybake.parent.getURL().then((data) => {
                    setBodyHeight('adobe-easybake-main-sub-pane')
                })
            }
    }, [window.easybake, page])

    function isDisabled() {
        // return false //TODO
        if (dMode) {
            return false
        }
        if (!formEnterpriseFullName || !formEnterpriseEmail || !formEnterpriseCompany || !formEnterpriseAgreement) {
            return true
        }
        return false
    }

    async function runSubmitEnterpriseForm(e) {
        try {
            e.preventDefault()
            analytics.sendEventName('click', `${page}:submitenterpriseform`)
            dispatch({ type: 'wait', payload: true })
            const res = await pUserInfo(uInfo, process.env.REACT_APP_CONFIG_APP_FORM_ENTERPRISE_ENDPOINT)
            if (res) {
                dispatch({ type: 'set-page', payload: { page: 'enterprisesetupmeeting'} })
            } else {
                dispatch({ type: 'set-page', payload: { page: 'contactsales'} })
            }
            dispatch({ type: 'wait', payload: false })
        } catch(e) {
            logAlert(e)
            dispatch({ type: 'wait', payload: false })
        }
    }

    return <div className="adobe-easybake-main-sub-pane">
        { wait && <div className="adobe-easybake-modal-loading">
            <Wait size="L" />
            <div>{__('console_sending_form')}</div>
        </div>}
        <div className="adobe-easybake-main-sub-pane-header">
            <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('enterprise_form_title')}</Heading>
            <br />
            <p>{__('enterprise_form_desc')}</p>
            <br />
        </div>

        <div className="adobe-easybake-main-contents">
            <div className="adobe-easybake-main-contents">
                <div className="adobe-easybake-box-parent">
                    <Form autoComplete="off">
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_name')} labelFor="tf-fullname">
                        <Textfield 
                            // validationState={isStringValid(formFullName) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_name')} 
                            id="tf-fullname" 
                            label="fullname"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formEnterpriseFullName}
                            onChange={ e => dispatch({ type: 'set-formEnterpriseFullName', payload: { formEnterpriseFullName: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEnterpriseFullName', payload: { formEnterpriseFullName: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_company')} labelFor="tf-company">
                        <Textfield
                            // validationState={isStringValid(formCompany) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_company_desc')} 
                            id="tf-company" 
                            label="company"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formEnterpriseCompany}
                            onChange={ e => dispatch({ type: 'set-formEnterpriseCompany', payload: { formEnterpriseCompany: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEnterpriseCompany', payload: { formEnterpriseCompany: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_email')} labelFor="tf-email">
                        <Textfield 
                            // validationState={isFormEmailValid(formEmail) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_email')} 
                            id="tf-email" 
                            label="email"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formEnterpriseEmail}
                            onChange={ e => dispatch({ type: 'set-formEnterpriseEmail', payload: { formEnterpriseEmail: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEnterpriseEmail', payload: { formEnterpriseEmail: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel label={__('signup_form_filed_label_phone')} labelFor="tf-phone">
                        <Textfield 
                            placeholder={__('signup_form_filed_label_phone')} 
                            id="tf-phone" 
                            label="phone"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formEnterprisePhone}
                            onChange={ e => dispatch({ type: 'set-formEnterprisePhone', payload: { formEnterprisePhone: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEnterprisePhone', payload: { formEnterprisePhone: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel label={__('signup_form_filed_label_use_case')} labelFor="tf-usecase">
                        <Textarea 
                            // validationState={isStringValid(formUseCase) ? 'valid' : 'invalid'}
                            id="tf-usecase" 
                            defaultValue={formEnterpriseUseCase}
                            label="usecase"
                            maxLength={MAX_STRING_LENGTH_LONG}
                            onChange={ e => dispatch({ type: 'set-formEnterpriseUseCase', payload: { formEnterpriseUseCase: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEnterpriseUseCase', payload: { formEnterpriseUseCase: e.target.value } }) }/>
                    </FieldLabel>
                    <br />
                    <FieldLabel label={__('signup_form_filed_label_estimated_volume')} labelFor="tf-phone">
                        <Textfield 
                            placeholder={__('signup_form_filed_label_estimated_volume')} 
                            id="tf-phone" 
                            label="phone"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formEnterpriseEstimatedVolume}
                            onChange={ e => dispatch({ type: 'set-formEnterpriseEstimatedVolume', payload: { formEnterpriseEstimatedVolume: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEnterpriseEstimatedVolume', payload: { formEnterpriseEstimatedVolume: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_enterprise')} labelFor="tf-agreement">
                        <div className="adobe-easybake-form-check-multi">
                            <Checkbox
                                // validationState={formEnterpriseAgreement ? 'valid' : 'invalid'}
                                onChange={ e => dispatch({ type: 'set-formEnterpriseAgreement', payload: { formEnterpriseAgreement: e } }) }
                                defaultValue={formEnterpriseAgreement}
                                renderLabel={false}
                                name="tf-agreement" />
                                <div className="adobe-easybake-form-check-multi-lines">By supplying my contact information, I authorize the <Link className="adobe-easybake-nav-link" referrer={`console:${page}:adobefamilycompanies`} label={__('signup_form_filed_label_enterprise_AdobeFamilyCompanies')} url={__('url_signup_form_filed_label_AdobeFamilyCompanies')} noBreak={true} />
                                <span className="adobe-easybake-space-left-right">to contact me via</span> <Link className="adobe-easybake-nav-link" referrer={`console:${page}:personalized`} label={__('signup_form_filed_label_enterprise_Personalized')} url={__('url_signup_form_filed_label_Personalized')} noBreak={true} />
                                <span className="adobe-easybake-space-left-right">communications about Adobe&apos;s products and services. See our <Link className="adobe-easybake-nav-link" referrer={`console:${page}:enterpriseprivatepolicy`} label={__('signup_form_filed_label_prerelease_desk_link_pp')} url={__('url_signup_form_filed_label_PrivacyPolicy')} noBreak={true} /> for more details or to <Link className="adobe-easybake-nav-link" referrer={`console:${page}:optout`} label={__('signup_form_filed_label_enterprise_OptOut')} url={__('url_signup_form_filed_label_OptOut')} noBreak={true} /> at any time.</span>
                                </div>
                        </div>
                    </FieldLabel>
                    <hr className="adobe-easybake-hr"/>
                    <div className="adobe-easybake-well-card-button">
                        {/* <Button quiet variant="primary" onClick={ e => cancel(e) }>{__('signup_form_filed_btn_cancel')}</Button> */}
                        <Button variant="cta" onClick={ e => runSubmitEnterpriseForm(e) } disabled={ isDisabled() }>{__('signup_form_filed_btn_ok')}</Button>
                    </div>
                    <br />
                    <p className="adobe-easybake-p">{__('signup_form_filed_label_prerelease_term')}
                        <Link className="adobe-easybake-nav-link" referrer={`console:${page}:learnmore`} label={__('signup_form_filed_label_prerelease_learn')} url={__('url_signup_form_filed_label_learn')} noBreak={true} />
                    </p>
                    </Form>
                </div>
                <br />
                <br />
                <br />
            </div>
        </div>
    </div>
}
